var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 96 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9403 11.7567H31.7161V0H35.9403C39.4631 0 41.631 2.20033 41.631 5.87837C41.631 9.54829 39.4631 11.7567 35.9403 11.7567ZM34.4259 9.3859H35.8446C37.8212 9.39402 38.9052 8.42782 38.9052 5.87837C38.9052 3.32079 37.8212 2.36271 35.8128 2.35459H34.4259V9.3859Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2155 0V11.7567H46.5056V0H49.2155Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4577 11.7567H54.2335V0H58.4577C61.9805 0 64.1484 2.20033 64.1484 5.87837C64.1484 9.54829 61.9805 11.7567 58.4577 11.7567ZM56.9434 9.3859H58.3621C60.3387 9.39402 61.4226 8.42782 61.4226 5.87837C61.4226 3.32079 60.3387 2.36271 58.3302 2.35459H56.9434V9.3859Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 29.8912V22.0011H3.43185C5.22114 22.0011 6.17507 23.1018 6.18045 24.6166C6.17507 26.126 5.21036 27.2212 3.41029 27.2212H1.90125V29.8912H0.5ZM1.90125 26.0551H3.21627C4.2726 26.0497 4.74687 25.4503 4.74687 24.6166C4.74687 23.772 4.2726 23.1889 3.21627 23.1889H1.90125V26.0551Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.831 29.8912V22.0011H14.2323V28.6924H17.6815V29.8912H12.831Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6147 29.8912H24.1165L26.8651 22.0011H28.5897L31.3491 29.8912H29.8508L29.1987 27.9405H26.2615L25.6147 29.8912ZM26.6387 26.7962H28.8214L27.7597 23.614H27.695L26.6387 26.7962Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5014 23.1889V22.0011H42.7208V23.1889H40.3171V29.8912H38.9158V23.1889H36.5014Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.339 29.8912V22.0011H54.3404V23.1889H50.7402V25.3467H53.9954V26.5346H50.7402V29.8912H49.339Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0079 25.9461C68.0133 28.4963 66.472 30.0002 64.4294 30.0002C62.376 30.0002 60.8454 28.4908 60.8508 25.9461C60.8454 23.396 62.376 21.8921 64.4294 21.8921C66.472 21.8921 68.0133 23.396 68.0079 25.9461ZM62.2628 25.9461C62.2574 27.7497 63.1575 28.7251 64.4294 28.7251C65.7067 28.7251 66.6013 27.7497 66.5959 25.9461C66.6013 24.1425 65.7067 23.1672 64.4294 23.1672C63.1575 23.1672 62.2574 24.1425 62.2628 25.9461Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7771 29.8912V22.0011H77.7089C79.4982 22.0011 80.4521 23.0146 80.4575 24.5185C80.4521 25.592 79.9671 26.3875 79.0509 26.7635L80.7378 29.8912H79.1748L77.6442 27.0032H76.1783V29.8912H74.7771ZM76.1783 25.8154H77.4933C78.5497 25.8208 79.0239 25.3631 79.0239 24.5185C79.0239 23.6794 78.5497 23.1889 77.4933 23.1889H76.1783V25.8154Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1835 22.0011H88.9081L91.2256 27.7334H91.3226L93.6401 22.0011H95.3647V29.8912H94.0173V24.464H93.9419L91.7753 29.8694H90.7729L88.6063 24.4422H88.5417V29.8912H87.1835V22.0011Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPGray);
export default __webpack_public_path__ + "static/media/logo-p-gray.8be04952927e7b48df97bda736bce994.svg";
export { ForwardRef as ReactComponent };